(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

class ProductRecommendations extends HTMLElement {

  constructor() {

    super();

    const handleIntersection = (entries, observer) => {

      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      fetch(this.dataset.url)

        .then(response => response.text())

        .then(text => {

          const html = document.createElement('div');

          html.innerHTML = text;

          const recommendations =
            html.querySelector('product-recommendations');


          /*
           * ==========================================
           * LOAD RECOMMENDATIONS
           * ==========================================
           */

          if (
            recommendations &&
            recommendations.innerHTML.trim().length
          ) {

            this.innerHTML = recommendations.innerHTML;

          }


          /*
           * ==========================================
           * INITIALIZE SWIPER
           * ==========================================
           */

          const swiperContainer =
            this.querySelector('.swiper-container');


          if (swiperContainer) {

            // FIX: this class is now added only once content
            // has actually loaded, instead of being present
            // in the markup from the start.
            this.classList.add(
              'product-recommendations--loaded'
            );

            const getID =
              swiperContainer.getAttribute('data-id');

            const spaceBetween =
              parseInt(
                swiperContainer.getAttribute(
                  'data-space-between'
                ),
                10
              );

            // FIX: parse to a real number. Swiper silently
            // ignores / misbehaves with a string value here.
            const perviewDesktop =
              parseInt(
                swiperContainer.getAttribute(
                  'data-perview-desktop'
                ),
                10
              ) || 4;


            new Swiper(swiperContainer, {

              slidesPerView: 'auto',

              freeMode: false,

              autoHeight: true,

              calculateHeight: true,

              freeModeSticky: true,

              centeredSlides: false,

              grabCursor: true,

              watchSlidesVisibility: true,

              watchSlidesProgress: true,

              preloadImages: true,

              updateOnImagesReady: true,

              spaceBetween: spaceBetween,

              observer: true,

              observeParents: true,

              parallax: true,

              a11y: true,

              keyboard: {
                enabled: true
              },


              breakpoints: {

                320: {
                  slidesPerView: 2,
                  spaceBetween: 20
                },

                576: {
                  slidesPerView: 2
                },

                768: {
                  slidesPerView: 3
                },

                992: {
                  slidesPerView: perviewDesktop
                }

              },


              scrollbar: {
                el: this.querySelector(
                  '.swiper-scrollbar'
                )
              },


              navigation: {

                nextEl: this.querySelector(
                  '.swiper-button-next'
                ),

                prevEl: this.querySelector(
                  '.swiper-button-prev'
                )

              }

            });

          }


          /*
           * ==========================================
           * JUDGE.ME REVIEW BADGES (real-time refresh)
           * ==========================================
           */

          const refreshJudgeMeReviews = () => {

            if (typeof jdgm === 'undefined') {
              return;
            }


            /*
             * Only bother refreshing if this section
             * actually rendered any review badges.
             */

            const badges =
              this.querySelectorAll(
                '.jdgm-preview-badge[data-id]'
              );


            if (!badges.length) {
              return;
            }


            try {

              if (
                typeof jdgm.customizeBadges ===
                'function'
              ) {

                jdgm.customizeBadges();

              }

            } catch (error) {

              console.warn(
                'Judge.me customize error:',
                error
              );

            }


            try {

              if (
                typeof jdgm.loadBadges ===
                'function'
              ) {

                jdgm.loadBadges();

              }

            } catch (error) {

              console.warn(
                'Judge.me load badges error:',
                error
              );

            }

          };


          // FIX: instead of relying only on blind
          // setTimeout guesses, hook into Judge.me's own
          // "loaded" event when it's available, so badges
          // refresh as soon as Judge.me is actually ready
          // rather than on a fixed delay.
          document.addEventListener(
            'judgeme:load',
            refreshJudgeMeReviews,
            { once: true }
          );

          document.addEventListener(
            'judgeme:widget:load',
            refreshJudgeMeReviews
          );

          // Fallback attempts in case Judge.me was already
          // loaded before this section rendered, or fires
          // no event at all in this theme/version.
          setTimeout(refreshJudgeMeReviews, 300);
          setTimeout(refreshJudgeMeReviews, 1000);
          setTimeout(refreshJudgeMeReviews, 2000);


        })

        .catch(error => {

          console.error(
            'Product recommendations error:',
            error
          );

        });

    };


    new IntersectionObserver(
      handleIntersection.bind(this),
      {
        rootMargin: '0px 0px 500px 0px'
      }
    ).observe(this);

  }

}


customElements.define(
  'product-recommendations',
  ProductRecommendations
);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
